module.exports = __webpack_public_path__ + "static/media/silkycloud-red-4.87df96b8.png";